<template>
  <img
    v-if="theme === 'hawaii'"
    :height="height"
    :style="{ height: `${height}px`, width: 'auto' }"
    alt="Hawaii Logo"
    src="/logo.png"
  />
  <img
    v-else
    :height="height"
    :style="{ height: `${height}px`, width: 'auto' }"
    alt="San-Remo Logo"
    src="/san-remo.png"
  />
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    height?: number
  }>(),
  {
    height: 32,
  },
)

const theme = import.meta.env.VITE_THEME_NAME
</script>
